import React, { Component, createRef } from "react";
import { QueryClient, QueryClientProvider } from "react-query";

import i18next from "i18next";

import "../FontAwesome";
import Header from "../components/Header";
import axios from "axios";
import randomIntFromInterval from "../utils/randomIntFromInterval";
import PropTypes from "prop-types";
import DetectFontChange from "../components/DetectFontChange";
import LayoutContent from "../components/LayoutContent";
import Main from "../components/Main";
import Modal from "../components/Modal";
import ModalTeam from "../components/ModalTeam";
import ModalQuestion from "../components/ModalQuestion";
import ModalIntroMedia from "../components/ModalIntroMedia";
import ModalOutroMedia from "../components/ModalOutroMedia";
import ModalPassword from "../components/ModalPassword";

import IntroductionScreen from "../components/IntroductionScreen";
import DecorativeLines4 from "../components/DecorativeLines4";
import { UserProvider } from "../components/Context";
import {
    minimumSession,
    maximumSession,
    sessionQuestionTimer,
    standardSessionTime,
} from "../utils/gameVariable";
import { async } from "regenerator-runtime";
import { Navigate } from "react-router-dom";
import {
    getStoredMembers,
    setStoredMembers,
    getStoredTimer,
    setStoredTimer,
    getStoredRemainingSeconds,
    setStoredRemainingSeconds,
    getIsGameActive,
    setIsGameActive,
    getStoredCategories,
    getStoredCurrentRound,
    setStoredCurrentRound,
    getStoredTotalRound,
    setStoredTotalRound,
    getStoredUsedGlobal,
    setStoredUsedGlobal,
} from "../utils/storage";
import { generateUniqId13 } from "../utils/generateUniqId13";

const queryClient = new QueryClient();
var usedGlobal = getStoredUsedGlobal([]);
var index = 0;

/**
 * Keep only question_category terms that have at least one question
 * in the sectors stored in localStorage. Sectors are not linked to
 * categories directly — the relationship goes through questions.
 */
const getCategoriesRelatedToSelectedSectors = (allCategories = []) => {
    const categories = Array.isArray(allCategories) ? allCategories : [];
    const selectedSectors = (getStoredCategories([]) || [])
        .map(Number)
        .filter((id) => !Number.isNaN(id));

    if (!selectedSectors.length) {
        return categories;
    }

    const hasSectorLinks = categories.some((category) =>
        Array.isArray(category.sector_ids),
    );

    if (!hasSectorLinks) {
        return categories;
    }

    return categories.filter((category) => {
        const sectorIds = (category.sector_ids || []).map(Number);
        return sectorIds.some((sectorId) => selectedSectors.includes(sectorId));
    });
};

/**
 * @augments {Component<Game.propTypes>}
 */
class Game extends Component {
    static propTypes = {
        isIframe: PropTypes.bool,
        mode: PropTypes.string,
    };

    static defaultProps = {
        isIframe: false,
        mode: "game",
    };

    childref = React.createRef();
    anotherChildRef = React.createRef();

    constructor(props) {
        super(props);
        this.handleMountWheelData = this.handleMountWheelData.bind(this);
        this.ModalQuestion = createRef();

        const isIntro =
            props.mode === "intro" ||
            window.location.pathname.includes("intro");
        const storedMembers = getStoredMembers([]);
        const storedTimer = getStoredTimer(standardSessionTime || 30);
        const isGameActive = getIsGameActive();
        const storedRemaining = getStoredRemainingSeconds();
        const initialRemaining =
            isGameActive && storedRemaining !== null && storedRemaining >= 0
                ? storedRemaining
                : storedTimer * 60;

        this.state = {
            baseUrl: window.baseUrl,
            exclude: window.exclude,
            logo: window.themes.logo,
            // Hide inside iframe
            isShow_header: !props.isIframe,
            // eslint-disable-next-line no-extra-boolean-cast
            // isOpen_instruction: !Boolean(parseInt(window.backend.set_password)),
            isOpen_instruction: isIntro,
            isOpen_about: false,
            isOpen_embed: false,
            isOpen_question: false,
            isOpen_intro_media: false,
            isOpen_outro_media: false,
            isOpen_team: false,
            isUse_password: Boolean(parseInt(window.backend.set_password)),
            isOpen_password: false,
            isNext_instruction: true,
            question: {
                icon_category: null,
                category_name: null,
                member: null,
                post_content: null,
            },
            color: null,
            text_color: null,
            categories: getCategoriesRelatedToSelectedSectors(
                window.categories,
            ),
            categories_isOpen: true,
            members: storedMembers,
            membersInactive: storedMembers,
            membersPlayed: [],
            membersPlaying: [],
            wheelTextStyle: null,
            selectedPlayer: "",
            // round progress
            currentRound: getStoredCurrentRound(0),
            currentTime: initialRemaining <= 0 ? 0 : 1,
            totalRound: getStoredTotalRound(1),
            // round states
            totalTimeSelected: storedTimer,
            remainingSeconds: initialRemaining,
            font_heading: window.fonts.heading.regular_font,
            font_body: window.fonts.body.regular_font,
            is_Play: isIntro ? "none" : "flex",
            is_Playing: !isIntro,
            is_Valid: false,
            isActive: !isIntro,
            showFinishWarning: false,
            scaleAnswer: null,
            isRewatchingMedia: false,
        };
    }

    handleMountWheelData() {
        this.props.addWheelData(this.state.members);
    }

    componentDidMount() {
        document.addEventListener("keyup", this.handleEscape);
        this.handleMountWheelData();

        if (this.state.is_Playing) {
            this.setCountDownTimer();
        }
    }

    componentWillUnmount() {
        document.removeEventListener("keyup", this.handleEscape);
        if (this.timerIntervalId) {
            clearInterval(this.timerIntervalId);
        }
    }

    handleEscape = (e) => {
        if (e.keyCode === 27) {
            this.setState({
                isOpen_about: false,
                isOpen_embed: false,
            });
        }
    };

    onChangeTimer = (timerValue) => {
        setStoredTimer(timerValue);
        const duration = timerValue * 60;
        setStoredRemainingSeconds(duration);
        this.setState({
            totalTimeSelected: timerValue,
            remainingSeconds: duration,
        });
    };

    restartSession = (newTimerValue) => {
        const timerVal = newTimerValue || this.state.totalTimeSelected;
        setStoredTimer(timerVal);
        const duration = timerVal * 60;
        setStoredRemainingSeconds(duration);
        setIsGameActive(false);
        if (this.timerIntervalId) {
            clearInterval(this.timerIntervalId);
        }

        usedGlobal = [];
        setStoredUsedGlobal(usedGlobal);
        setStoredCurrentRound(0);

        if (typeof this.props.resetTeamActions === "function") {
            this.props.resetTeamActions();
        }

        this.setState({
            totalTimeSelected: timerVal,
            remainingSeconds: duration,
            currentTime: 1,
            currentRound: 0,
            membersPlayed: [],
            membersPlaying: [],
            membersInactive: [...this.state.members],
        });
    };

    onStart = (members) => {
        setStoredMembers(members);
        const wasGameActive = getIsGameActive();
        const storedRemaining = getStoredRemainingSeconds();
        const hasRemainingTime =
            storedRemaining !== null &&
            !isNaN(storedRemaining) &&
            storedRemaining > 0;

        let duration;
        if (wasGameActive && hasRemainingTime) {
            // Keep existing remaining timer (timer was paused during change team)
            duration = storedRemaining;
        } else {
            // New session start
            duration = this.state.totalTimeSelected * 60;
            setStoredRemainingSeconds(duration);
        }

        setIsGameActive(true);

        const currentMembers =
            members && members.length > 0 ? members : this.state.members;
        let newMembersInactive = [...currentMembers];
        let newMembersPlaying = [];
        let newMembersPlayed = [];

        if (newMembersInactive.length > 0) {
            const maxIndex = newMembersInactive.length - 1;
            const random = randomIntFromInterval(0, maxIndex);
            newMembersPlaying = newMembersInactive.splice(random, 1);
            newMembersPlayed = [...newMembersPlaying];
        }

        const newTotalRound = Math.ceil(
            this.state.totalTimeSelected / sessionQuestionTimer,
        );

        if (!wasGameActive) {
            setStoredTotalRound(newTotalRound);
            setStoredCurrentRound(0);
            usedGlobal = [];
            setStoredUsedGlobal(usedGlobal);
        }

        this.setState({
            members: currentMembers,
            membersInactive: newMembersInactive,
            membersPlaying: newMembersPlaying,
            membersPlayed: newMembersPlayed,
            isOpen_team: false,
            remainingSeconds: duration,
            totalRound: wasGameActive ? this.state.totalRound : newTotalRound,
            isOpen_about: false,
            isOpen_embed: false,
            isOpen_password: false,
        });

        this.setCountDownTimer();

        if (this.props.onGameStart) {
            this.props.onGameStart();
        }
    };

    setCountDownTimer = () => {
        if (this.timerIntervalId) {
            clearInterval(this.timerIntervalId);
        }

        let timer =
            this.state.remainingSeconds !== undefined &&
            this.state.remainingSeconds !== null
                ? this.state.remainingSeconds
                : this.state.totalTimeSelected * 60;

        if (timer <= 0) {
            this.setState({ remainingSeconds: 0, currentTime: 0 });
            setStoredRemainingSeconds(0);
            this.isMaxTimer();
            return;
        }

        this.setState({ remainingSeconds: timer, currentTime: timer });

        this.timerIntervalId = setInterval(() => {
            timer = timer - 1;

            if (timer <= 0) {
                clearInterval(this.timerIntervalId);
                this.setState({ remainingSeconds: 0, currentTime: 0 });
                setStoredRemainingSeconds(0);
                this.isMaxTimer();
            } else {
                this.setState({ remainingSeconds: timer, currentTime: timer });
                setStoredRemainingSeconds(timer);
            }
        }, 1000);
    };

    onSubmitTeamAction = (data) => {
        const hasOutro = Boolean(
            this.state.question &&
                this.state.question.has_outro &&
                this.state.question.question_outro,
        );

        const nextRound = this.state.currentRound + 1;
        setStoredCurrentRound(nextRound);

        this.setState({
            isOpen_question: false,
            currentRound: nextRound,
            isRewatchingMedia: false,
            scaleAnswer: null,
        });

        if (hasOutro) {
            setTimeout(() => {
                this.setState({
                    isOpen_outro_media: true,
                });
            }, 220);
        }

        if (nextRound > this.state.totalRound) {
            setStoredTotalRound(nextRound);
            this.setState({
                totalRound: nextRound,
            });
        }

        let categoryId = null;
        let questionId = null;
        const teamActionsData = {};

        const actions = Array.isArray(data)
            ? data
            : data !== "" && data !== null && data !== undefined
              ? [data]
              : [];

        if (actions.length > 0) {
            let categoryName =
                this.state.question?.category_name ||
                this.state.question?.category ||
                "";
            let categoryColor =
                this.state.color || this.state.question?.color || "#00A3E0";
            categoryId = this.state.question?.category_id || "";
            questionId = this.state.question?.question_id || "";

            if (
                !categoryName &&
                this.state.question?.category_id &&
                this.state.categories
            ) {
                const foundCat = this.state.categories.find(
                    (c) =>
                        Number(c.category_id) ===
                        Number(this.state.question.category_id),
                );
                if (foundCat) {
                    categoryId = foundCat.category_id;
                    categoryName = foundCat.category_name;
                    categoryColor = foundCat.color || categoryColor;
                    questionId = foundCat.question_id;
                }
            }

            // const currentPlayer =
            //     this.state.selectedPlayer ||
            //     (this.state.membersPlaying && this.state.membersPlaying[0]) ||
            //     "";

            // const playerName =
            //     typeof currentPlayer === "object"
            //         ? currentPlayer?.name || currentPlayer?.member || ""
            //         : String(currentPlayer || "");

            actions.forEach((act) => {
                const textVal = typeof act === "string" ? act : act?.text || "";
                const actionId = generateUniqId13();
                if (textVal && textVal.trim().length > 0) {
                    const teamActionObj =
                        typeof act === "string"
                            ? {
                                  text: act.trim(),
                                  categoryId: categoryId,
                                  categoryName: categoryName,
                                  categoryColor: categoryColor,
                                  // playerName: playerName,
                                  questionId: questionId,
                                  actionId: actionId,
                              }
                            : {
                                  text: (act.text || "").trim(),
                                  categoryId: act.categoryId || categoryId,
                                  categoryName:
                                      act.categoryName || categoryName,
                                  categoryColor:
                                      act.categoryColor || categoryColor,
                                  // playerName: act.playerName || playerName,
                                  questionId: act.questionId || questionId,
                                  actionId: actionId,
                              };

                    teamActionsData[actionId] = teamActionObj.text;
                    this.props.addTeamAction(teamActionObj);
                }
            });
        }

        const storedQuestionId = this.state.question.stored_question_id;
        if (storedQuestionId) {
            const gameProgressId = window?.themes?.user?.current_game_progress;

            axios.post(
                window.themeObj.restURL + "/game/save-question-note-or-answer",
                {
                    stored_question_id: storedQuestionId,
                    answer: this.state.scaleAnswer,
                    team_actions: teamActionsData,
                    game_progress_id: gameProgressId,
                    question_category_id: categoryId,
                    question_id: questionId,
                },
            );
        }
    };

    onSubmitScaleAnswer = (data) => {
        this.setState({ scaleAnswer: data.answer });
    };

    onOpen_about = () => {
        this.setState({ isOpen_about: true });
    };

    onOpen_instruction = () => {
        this.setState({ isOpen_instruction: true });
        this.childref.current.noTeamAction();
    };

    onClose_instruction = () => {
        this.setState({ isOpen_instruction: false });
    };

    onBlur = () => {
        this.setState({ isBlur_instruction: true });
    };

    onClose_team = () => {
        this.setState({ isOpen_team: false });
    };

    onClose_about = () => {
        this.setState({ isOpen_about: false });
    };

    onNext_instruction = () => {
        this.setState({ isNext_instruction: false });
    };

    onNext_addteam = () => {
        this.setState({
            isOpen_instruction: true,
            isActive: false,
        });
        // this.setState({ isNext_instruction: false });
        this.childref.current.isTeamAction();
    };

    isMaxAlert = () => {
        this.childref.current.isMaxRound();
        this.childref.current.isMaxAlert();
    };

    isMaxChar = () => {
        this.childref.current.isMaxChar();
        this.childref.current.isMaxRound();
    };

    isMaxTimer = () => {
        if (this.childref.current) {
            this.childref.current.isMaxRound();
            this.childref.current.isMaxTimer();
        }
    };

    isDisableFromModal = () => {
        // console.log(this.ModalQuestion.current);
    };

    onOpen_embed = () => {
        this.setState({ isOpen_embed: true });
    };

    onClose_embed = () => {
        this.setState({ isOpen_embed: false });
    };

    onOpen_editMember = () => {
        this.setState({
            isOpen_team: true,
        });
    };

    onSet_Play = () => {
        this.setState({
            is_Play: "flex",
            is_Playing: true,
            isActive: true,
        });
    };

    isValid = () => {
        this.setState({
            is_Valid: true,
        });
    };

    onToggleCategory = () => {
        this.setState((prevState) => ({
            categories_isOpen: !prevState.categories_isOpen,
        }));
    };

    onSelectedPlayer = (player) => {
        this.setState({ selectedPlayer: player });
    };

    getColorByCategoryId = (categoryId) => {
        const cat = this.state.categories;

        const col = cat.filter((catId) => catId.category_id === categoryId);

        if (col.length > 0) {
            return col[0];
        } else {
            return {
                color: "#81d742",
                text_color: "#000000",
            };
        }
    };

    onWheelSelect = async (id) => {
        const membersInactive = this.state.membersInactive;
        const membersPlayed = this.state.membersPlayed;
        const gameProgressId = window?.themes?.user?.current_game_progress;
        const selectedPlayer = this.state.selectedPlayer;
        // const baseUrl = this.state.baseUrl;
        // const excludeString = this.state.exclude.toString();
        // const url = `${baseUrl}/wp-json/api/v1/the_question/cat/${id}?exclude=${excludeString}`;
        const questionUrl =
            window.themeObj.restURL + "/game/game-spin-the-wheel";
        const { color, text_color } = this.getColorByCategoryId(parseInt(id));
        const storedCategories = getStoredCategories([]);
        const request = axios.post(questionUrl, {
            game_progress_id: gameProgressId,
            team_member: selectedPlayer,
            used_question: usedGlobal,
            category_id: parseInt(id),
            index: index,
            sectors: storedCategories,
        });

        request.then((response) => {
            var questData = response.data.data.rand_question;

            usedGlobal = questData.used;
            setStoredUsedGlobal(usedGlobal);
            index = questData.index;

            const dataNotFound = {
                post_id: 9999,
                post_title: i18next.t("No question found"),
                post_content: i18next.t("No question found"),
                category_id: 9999,
                category_name: "-",
            };

            const data = questData ? questData.quest : dataNotFound;

            let newMembersPlaying;
            let newMembersPlayed;
            let newMembersInactive;

            if (membersInactive.length > 0) {
                newMembersInactive = [...membersInactive];
                newMembersPlayed = [...membersPlayed];
            } else {
                // Restart
                newMembersInactive = [...membersPlayed];
                newMembersPlayed = [];

                // TODO: Debug
            }

            const maxIndex = newMembersInactive.length - 1;
            const random = randomIntFromInterval(0, maxIndex);

            newMembersPlaying = newMembersInactive.splice(random, 1);
            newMembersPlayed = [...newMembersPlayed, ...newMembersPlaying];

            // TODO: Debug

            const hasIntro = Boolean(
                data && data.has_intro && data.question_intro,
            );

            this.setState({
                membersInactive: newMembersInactive,
                membersPlaying: newMembersPlaying,
                membersPlayed: newMembersPlayed,
                // exclude: newExclude,
                question: data,
                isOpen_intro_media: hasIntro,
                isOpen_outro_media: false,
                isOpen_question: !hasIntro,
                color: color,
                text_color: text_color,
                isRewatchingMedia: false,
                scaleAnswer: null,

                // Close All the Modal that possibly open
                isOpen_about: false,
                isOpen_embed: false,
                isOpen_team: false,
                isOpen_password: false,
            });
        });
    };

    onFinishIntroMedia = () => {
        this.setState({
            isOpen_intro_media: false,
        });
        setTimeout(() => {
            this.setState({
                isOpen_question: true,
            });
        }, 220);
    };

    onRewatchMedia = () => {
        this.setState({
            isOpen_question: false,
            isRewatchingMedia: true,
        });
        setTimeout(() => {
            this.setState({
                isOpen_intro_media: true,
            });
        }, 220);
    };

    onCloseQuestion = () => {
        const hasOutro = Boolean(
            this.state.question &&
                this.state.question.has_outro &&
                this.state.question.question_outro,
        );

        this.setState({
            isOpen_question: false,
        });

        if (hasOutro) {
            setTimeout(() => {
                this.setState({
                    isOpen_outro_media: true,
                });
            }, 220);
        }
    };

    onFinishOutroMedia = () => {
        this.setState({
            isOpen_outro_media: false,
        });
    };

    onFinishClick = (e) => {
        if (e) {
            e.preventDefault();
        }
        this.setState({ showFinishWarning: true });
    };

    onCancelFinish = () => {
        this.setState({ showFinishWarning: false });
    };

    onFinishGame = () => {
        this.setState({ showFinishWarning: false });
        setIsGameActive(false);

        const baseUrl = window.themeObj?.restURL;
        const gpID = window.themes?.user?.current_game_progress;
        const gameMembers = this.state.members;
        const apiURL = `${baseUrl}/game/finish-game`;
        axios
            .post(apiURL, {
                game_progress_id: gpID,
                game_members: gameMembers,
            })
            .then(() => {
                if (this.props.onFinish) {
                    this.props.onFinish();
                } else {
                    this.setState({ redirectToEndPage: true });
                }
            })
            .catch((err) => {
                console.error(err);
                if (this.props.onFinish) {
                    this.props.onFinish();
                } else {
                    this.setState({ redirectToEndPage: true });
                }
            });
    };

    onLogin = () => {
        /**
         * Why don't you combine the setState? to prevent unexpected double
         * scrollbar when Modal open (see Modal->useEffect), because it's async
         * task, with callback schema you can make sure the scrollbar update in the
         * right flow.
         *
         * Expected flow:
         * 1. Close Modal Password
         * 2. Update scrollbar (useEffect)
         * 3. Open Modal Team
         * 4. Update scrollbar (useEffect)
         */
        // set isOpen_team to false since it wont be needed
        const openTeam = this.setState({ isOpen_team: false });
        this.setState({ isOpen_password: false }, openTeam);
    };

    forceRerenderWheel = (textStyle) => {
        this.setState({
            wheelTextStyle: textStyle,
        });
    };

    render() {
        if (this.state.redirectToEndPage) {
            return <Navigate to="/end-page" />;
        }

        const isRequredLogin =
            parseInt(window.themes.user) === 0 &&
            parseInt(window.themes.required_login) === 1;
        if (isRequredLogin) {
            return <Navigate to="/login" />;
        }

        return (
            <UserProvider value={this.state}>
                <QueryClientProvider client={queryClient}>
                    <DetectFontChange onChange={this.forceRerenderWheel} />
                    <LayoutContent>
                        {!this.state.isOpen_instruction && (
                            <DecorativeLines4 variant="game" label="GAME" />
                        )}
                        {this.state.isShow_header && (
                            <Header
                                logo={this.state.logo}
                                isWithEmbed={Boolean(
                                    parseInt(window.button_color.show_embed),
                                )}
                                // Pass props for about button
                                aboutButton={{
                                    text: window.main_button.about_button
                                        ? window.main_button.about_button
                                        : i18next.t("About"),
                                    background: window.themes
                                        ?.secondary_use_single_color
                                        ? window.themes.secondary_color
                                        : `linear-gradient(${
                                              window.themes
                                                  ?.secondary_color_gradient
                                                  ?.direction
                                          }, ${
                                              window.themes
                                                  ?.secondary_color_gradient
                                                  ?.gradient_colors[0]?.color
                                          } 0%, ${
                                              window.themes
                                                  ?.secondary_color_gradient
                                                  ?.gradient_colors[1]?.color
                                          } 100%)`,
                                    onClick: this.onOpen_about,
                                }}
                                // Pass props for edit team member button
                                editMember={{
                                    // text: window.button.button_team_member,
                                    text: window.main_button.change_team_button
                                        ? window.main_button.change_team_button
                                        : i18next.t("Change Team"),
                                    color: window.button_color
                                        .text_member_color,
                                    background: window.themes
                                        ?.secondary_use_single_color
                                        ? window.themes.secondary_color
                                        : `linear-gradient(${
                                              window.themes
                                                  ?.secondary_color_gradient
                                                  ?.direction
                                          }, ${
                                              window.themes
                                                  ?.secondary_color_gradient
                                                  ?.gradient_colors[0]?.color
                                          } 0%, ${
                                              window.themes
                                                  ?.secondary_color_gradient
                                                  ?.gradient_colors[1]?.color
                                          } 100%)`,

                                    onClick: this.onNext_addteam,
                                }}
                                // Pass props for embed button
                                embedButton={{
                                    text: window.button.button_embed
                                        ? window.button.button_embed
                                        : i18next.t("Embed"),
                                    color: window.button_color.text_embed_color,
                                    background: window.themes
                                        ?.secondary_use_single_color
                                        ? window.themes.secondary_color
                                        : `linear-gradient(${
                                              window.themes
                                                  ?.secondary_color_gradient
                                                  ?.direction
                                          }, ${
                                              window.themes
                                                  ?.secondary_color_gradient
                                                  ?.gradient_colors[0]?.color
                                          } 0%, ${
                                              window.themes
                                                  ?.secondary_color_gradient
                                                  ?.gradient_colors[1]?.color
                                          } 100%)`,
                                    onClick: this.onOpen_embed,
                                }}
                                instructionButton={{
                                    text: i18next.t("Instructions"),
                                    color: window.button_color.text_embed_color,
                                    background: window.themes
                                        ?.secondary_use_single_color
                                        ? window.themes.secondary_color
                                        : `linear-gradient(${
                                              window.themes
                                                  ?.secondary_color_gradient
                                                  ?.direction
                                          }, ${
                                              window.themes
                                                  ?.secondary_color_gradient
                                                  ?.gradient_colors[0]?.color
                                          } 0%, ${
                                              window.themes
                                                  ?.secondary_color_gradient
                                                  ?.gradient_colors[1]?.color
                                          } 100%)`,
                                    onClick: this.onOpen_instruction,
                                }}
                                finishSession={{
                                    text: window.main_button
                                        .finish_session_button
                                        ? window.main_button
                                              .finish_session_button
                                        : i18next.t("Finish Session"),
                                    color: "white",
                                    background: window.themes
                                        ?.primary_use_single_color
                                        ? window.themes.primary_color
                                        : `linear-gradient(${
                                              window.themes
                                                  ?.primary_color_gradient
                                                  ?.direction
                                          }, ${
                                              window.themes
                                                  ?.primary_color_gradient
                                                  ?.gradient_colors[0]?.color
                                          } 0%, ${
                                              window.themes
                                                  ?.primary_color_gradient
                                                  ?.gradient_colors[1]?.color
                                          } 100%)`,
                                    onClick: this.onFinishClick,
                                }}
                                langSwitcher={window.themes.headerLangSwitcher}
                                color={window.button_color.text_member_color}
                                background={`linear-gradient(0deg, #086E5C 0%, #73DBA9 100%)`}
                                display={this.state.is_Play}
                                isPlaying={!this.state.isOpen_instruction}
                                sessionRemainingSeconds={
                                    this.state.remainingSeconds
                                }
                                totalSessionMinutes={
                                    this.state.totalTimeSelected
                                }
                                onOpenPassword={this.onOpenPassword}
                                usePassword={this.state.isUse_password}
                                login={this.props.login}
                            />
                        )}

                        <Main
                            categoryList={this.state.categories}
                            members={this.state.members}
                            onSelectMember={this.onSelectedPlayer}
                            // Pass props for Wheel component, see: Wheel PropTypes
                            wheel={{
                                data: this.state.categories,
                                isCustomLogo:
                                    window.button.custom_button_spinner,
                                buttonText: window.button.button_spinner,
                                buttonLogo: window.button.button_spinner_logo,
                                buttonColor:
                                    window.button_color.text_spin_color,
                                buttonBg: window.button_color.button_spin_color,
                                onSelect: this.onWheelSelect,
                                textStyle: this.state.wheelTextStyle,
                            }}
                            isOpenQuestion={this.state.isOpen_question}
                            currentRound={this.state.currentRound}
                            currentTime={this.state.currentTime}
                            totalRound={this.state.totalRound}
                            isMaxAlert={this.isMaxAlert}
                            result={this.state.selectedPlayer}
                            isActive={this.state.isActive}
                        />

                        <Modal
                            isOpen={this.state.isOpen_about}
                            onClose={this.onClose_about}
                        >
                            <h3 className="modal-inner-title">
                                {window.about.title}
                            </h3>
                            <div
                                className="modal-inner-content"
                                dangerouslySetInnerHTML={{
                                    __html: window.about.text,
                                }}
                            />
                        </Modal>

                        {/* <ModalEmbed
              baseUrl={this.state.baseUrl}
              widthPlaceholder={window.embed.width}
              heightPlaceholder={window.embed.height}
              // Pass props for generate button
              generateButton={{
                text: window.embed.generate,
                color: window.button_color.text_generate_color,
                background: window.button_color.button_generate_color,
              }}
              isOpen={this.state.isOpen_embed}
              onClose={this.onClose_embed}
            /> */}

                        <ModalTeam
                            image={window.welcome.logo_welcome}
                            title={window.welcome.title_welcome}
                            teamMembers={this.state.members}
                            content={window.welcome.text_welcome}
                            formTitle={window.member.choose}
                            onClose={this.onClose_team}
                            isOpen={this.state.isOpen_team}
                            startButton={{
                                text: window.member.start,
                            }}
                            leaveButton={{
                                text: i18next.t("Leave"),

                                onClick: this.onClose_team,
                                background:
                                    "linear-gradient(0deg, #D3341E 0%, #F17871 100%)",
                            }}
                            onStart={this.onStart}
                            langSwitcher={window.welcome.lang_switcher}
                            headerColor="white"
                            headerBg={`linear-gradient(0deg, rgba(8, 110, 92, 1) 0%, rgba(115, 219, 169, 1) 100%)`}
                        />

                        <IntroductionScreen
                            headerColor="white"
                            buttonBackground={`linear-gradient(0deg, rgb(211, 161, 30) 0%, rgb(241, 205, 113) 100%)`}
                            onClose={this.onClose_instruction}
                            onSetPlay={this.onSet_Play}
                            title={window.instruction.instruction_title}
                            text={window.instruction.instruction_text}
                            textInstruction={
                                window.instruction.text_instruction
                            }
                            isOpen={this.state.isOpen_instruction}
                            isBlur={this.state.isOpen_password ? true : false}
                            teamMembers={this.state.members}
                            langSwitcher={window.themes.headerLangSwitcher}
                            onStart={this.onStart}
                            instructionPageButton={{
                                text: window.welcome.welcome_button_next
                                    ? window.welcome.welcome_button_next
                                    : i18next.t("Next"),
                                background: "#FDD100",
                                color: "#10069F",
                            }}
                            playGameButton={{
                                text: window.setup_team.button_next
                                    ? window.setup_team.button_next
                                    : i18next.t("Play Game"),
                                background: "#FDD100",
                                color: "#10069F",
                            }}
                            next={this.state.isNext_instruction}
                            wheel={{
                                data: this.state.categories,

                                isCustomLogo:
                                    window.button.custom_button_spinner,
                                buttonText: window.button.button_spinner,
                                buttonLogo: window.button.button_spinner_logo,
                                buttonColor:
                                    window.button_color.text_spin_color,
                                buttonBg: window.button_color.button_spin_color,
                                onSelect: this.onWheelSelect,
                                textStyle: this.state.wheelTextStyle,
                            }}
                            categoryList={this.state.categories}
                            members={this.state.members}
                            nextInstructionButton={{
                                text: i18next.t("Next"),
                                onClick: this.onNext_instruction,
                            }}
                            isDisable={this.isDisableFromModal}
                            ref={this.childref}
                            minimumSession={minimumSession}
                            maximumSession={maximumSession}
                            standardSessionTime={standardSessionTime}
                            selectedTimer={this.state.totalTimeSelected}
                            onChangeTimer={this.onChangeTimer}
                            onRestartSession={this.restartSession}
                            isGameActive={getIsGameActive()}
                            onOpenPassword={this.onOpenPassword}
                            login={this.props.login}
                            usePassword={this.state.isUse_password}
                            onFinishGame={this.onFinishGame}
                        />

                        <ModalIntroMedia
                            isOpen={this.state.isOpen_intro_media}
                            mediaUrl={this.state.question.question_intro}
                            mediaType={this.state.question.intro_type}
                            title={this.state.question.category_name}
                            onContinue={this.onFinishIntroMedia}
                        />

                        <ModalOutroMedia
                            isOpen={this.state.isOpen_outro_media}
                            mediaUrl={this.state.question?.question_outro}
                            mediaType={this.state.question?.outro_type}
                            title={this.state.question?.category_name}
                            onContinue={this.onFinishOutroMedia}
                        />

                        <ModalQuestion
                            ref={this.ModalQuestion}
                            image={this.state.question.icon_category}
                            title={this.state.question.category_name}
                            member={this.state.selectedPlayer}
                            memberFor={window.question.for}
                            question={this.state.question.post_content}
                            additionalGuidingQuestion={
                                this.state.question
                                    ?.additional_guiding_questions ||
                                this.state.question?.additional_guiding_question
                            }
                            additionalGuidingQuestions={
                                this.state.question
                                    ?.additional_guiding_questions ||
                                this.state.question?.additional_guiding_question
                            }
                            hasScale={Boolean(
                                this.state.question &&
                                    (this.state.question.has_scale ||
                                        this.state.question.has_a_scale),
                            )}
                            scaleType={this.state.question?.scale_type}
                            scaleLabels={this.state.question?.scale_labels}
                            color={this.state.color}
                            text_color={this.state.text_color}
                            headerColor="white"
                            headerBg={`linear-gradient(0deg, rgba(8, 110, 92, 1) 0%, rgba(115, 219, 169, 1) 100%)`}
                            onClose={this.onCloseQuestion}
                            onSubmitTeamAction={this.onSubmitTeamAction}
                            onSubmitScaleAnswer={this.onSubmitScaleAnswer}
                            time={parseInt(window.timerDuration) * 60}
                            isOpen={this.state.isOpen_question}
                            isMaxChar={this.isMaxChar}
                            hasMedia={Boolean(
                                this.state.question &&
                                    this.state.question.has_intro &&
                                    this.state.question.question_intro,
                            )}
                            introType={this.state.question?.intro_type}
                            onRewatchMedia={this.onRewatchMedia}
                            isRewatch={this.state.isRewatchingMedia}
                        />

                        <ModalPassword
                            title={window.button.login_text}
                            invalidText={window.button.invalid_password}
                            loginButton={{
                                text: window.button.enter_password,
                                color: window.button_color.text_login_color,
                                background: window.themes.primary_color,
                            }}
                            password={window.backend.choose_pw}
                            onLogin={this.onLogin}
                            isOpen={this.state.isOpen_password}
                            isValid={this.isValid}
                        />

                        {this.state.showFinishWarning && (
                            <div className="restart-session-modal-overlay">
                                <div className="restart-session-modal">
                                    <h3 className="restart-session-modal__title">
                                        {
                                            window.sessions
                                                ?.finish_session_popup?.title
                                        }
                                    </h3>
                                    <p className="restart-session-modal__desc">
                                        {
                                            window.sessions
                                                ?.finish_session_popup?.subtitle
                                        }
                                    </p>
                                    <div className="restart-session-modal__actions">
                                        <button
                                            type="button"
                                            className="restart-session-modal__btn restart-session-modal__btn--cancel"
                                            onClick={this.onCancelFinish}
                                        >
                                            {
                                                window.sessions
                                                    ?.finish_session_popup
                                                    ?.cancel_button_text
                                            }
                                        </button>
                                        <button
                                            type="button"
                                            className="restart-session-modal__btn restart-session-modal__btn--confirm"
                                            onClick={this.onFinishGame}
                                        >
                                            {
                                                window.sessions
                                                    ?.finish_session_popup
                                                    ?.finish_button_text
                                            }
                                        </button>
                                    </div>
                                </div>
                            </div>
                        )}
                        {/* <Notification /> */}
                    </LayoutContent>
                </QueryClientProvider>
            </UserProvider>
        );
    }
}

export default Game;
